import { useQuery } from '@hooks/reactQuery';

import { getAutoSwitchAvailable } from '@api/networkElements';

import { extractQueryParams } from '@utils/common';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_AUTO_SWITCH_AVAILABLE } from '@constants/queryKeys';

interface IUseQueryAutoSwitchAvailable {
	isAutoSwitchAvailable: boolean;
	isLoadingAutoSwitchAvailable: boolean;
}

const useQueryAutoSwitchAvailable = (id?: string): IUseQueryAutoSwitchAvailable => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_AUTO_SWITCH_AVAILABLE, id],
		queryFn: extractQueryParams(getAutoSwitchAvailable),
		enabled: [!!id],
		allowedRoles: [EUserRoles.smoLightViewer, EUserRoles.smoLightUpdater],
		...refetchOptions,
	});

	return {
		isAutoSwitchAvailable: data?.isAutoSwitchAvailable || false,
		isLoadingAutoSwitchAvailable: isLoading || isFetching,
	};
};

export default useQueryAutoSwitchAvailable;
